module.exports = __webpack_public_path__ + "static/media/mola.d9e0ac3b.png";